import { render, staticRenderFns } from "./InsFooterSwiper.vue?vue&type=template&id=28f8cd1a&scoped=true&"
import script from "./InsFooterSwiper.vue?vue&type=script&lang=ts&"
export * from "./InsFooterSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./InsFooterSwiper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f8cd1a",
  null
  
)

export default component.exports